'use client';
import { useEffect, useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { getToken, getUser } from '@/lib/api-client';

// Public paths that do NOT require authentication
// patient-portal uses token-based access (no JWT required)
// share/ uses share-token-based access (no JWT required)
// reset-password uses reset-token-based access (no JWT required)
const PUBLIC_PATHS = ['/login', '/sign-up-login-screen', '/share/', '/patient-portal', '/reset-password'];

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = getToken();
    const user = getUser();
    const isPublic = PUBLIC_PATHS.some((p) => pathname.startsWith(p));

    if (!token || !user) {
      if (!isPublic) {
        router.replace('/login');
        return;
      }
    } else {
      if (isPublic) {
        router.replace('/dashboard');
        return;
      }
    }
    setChecked(true);
  }, [pathname, router]);

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-slate-500">Loading RadLab…</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
